import { ApiClient, RealtimeSocket, wsUrl } from '@despachador/api-client';

const BASE = import.meta.env.VITE_API_URL ?? '';

/** The driver app's client: its own refresh cookie (`desp_rt_driver`) and session across tabs. */
export const api = new ApiClient(BASE, { app: 'driver' });

/** The single realtime connection of the app (offers, presence, voice, service updates). */
export const socket = new RealtimeSocket(wsUrl(BASE), api.session);
